import $ from "jquery";
import axios from "axios";

(() => {
    const favorite = {
        init: function () {
            const count_cont = $('.js-favorite-count');
            $('body').on('click', '.js-favorite-toggle', function (e) {
                e.preventDefault();
                const $this = $(this),
                    was = $this.hasClass('active');
                axios.post(route('catalog.product.favorite.' + (was ? 'delete' : 'add'), $this.data('id')), {_method: was ? 'DELETE' : 'POST'})
                    .then(function (response) {
                        if (response.data.status === 'ok') {
                            $this.toggleClass('active');
                            count_cont.text(response.data.count);
                            new Noty({
                                text: response.data.message,
                                type: 'success'
                            }).show();
                        }
                    })
                    .catch(function (data) {
                        if (data.response.status === 401) {
                            new Noty({
                                text: 'Вы должны быть авторизованы для добавления в избранное',
                                type: 'error'
                            }).show();
                        }
                    });
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/favorite.js